import axios from "axios";

axios.defaults.baseURL =
  process.env.VUE_APP_API_HOST ?? "http://localhost:5000";

export default axios;
